import ServicePage from './ServicePage';
import { Package } from 'lucide-react';

const PROVIDERS = [
  { name: 'Radical Storage', desc: 'Store your luggage safely near stations, airports, and attractions worldwide. Flat rate, fully insured.', url: 'https://radicalstorage.tpm.lv/SkQdLUhy', icon: Package, color: 'from-rose-500 to-rose-600', tagline: 'Flat Rate Storage' },
];

export default function LuggageStoragePage() {
  return <ServicePage title="Luggage Storage" subtitle="Drop your bags at secure locations near stations, airports, and top attractions worldwide." icon={Package} providers={PROVIDERS} testId="luggage-storage-page" />;
}
